module.exports = __webpack_public_path__ + "static/img/ecom-03.830308a5.jpg";